import { ApiError } from "@wellcheck/api-client";

/**
 * isAnswerClosedError — POST /api/respondent-answers の 409 が
 * 「回答期間終了 (ADR-0032)」によるものかを判定する。
 *
 * backend (handlers/answers.go submit) は 409 を 3 種類 (二重提出 / 提出不可 / 回答期間終了) とも
 * huma.Error409Conflict の detail 文字列でしか区別しない (機械可読な discriminator はない)。
 * useSubmitAnswers はそれ以外の 409 を一律 SubmittedScreen に倒す既存方針だが、回答期間終了は
 * 「再送しても回答できない」ことを伝える別文言が必要 (ADR-0032) なため、detail 文字列で判別する。
 *
 * detail 文言はサーバ側の契約として明示されていない実装依存の値のため、ここでの判定が
 * backend の文言変更に対して脆いことは許容する (ADR-0032 スコープの範囲では他に判別手段がない)。
 */
const ANSWER_CLOSED_DETAIL = "answer period closed";

export function isAnswerClosedError(error: unknown): boolean {
  if (!(error instanceof ApiError) || error.status !== 409) {
    return false;
  }
  const data = error.data;
  if (typeof data !== "object" || data === null || !("detail" in data)) {
    return false;
  }
  return (data as { detail: unknown }).detail === ANSWER_CLOSED_DETAIL;
}
